import React from 'react';

import Config from '../../../shared/config/Configuration';

import styles from './Contact.module.scss';


class Contact extends React.Component {
  render() {
    return (
      <div className={styles.Contact}>
        <h3>{Config.companyName}</h3>
        <p><a href='https://goo.gl/maps/nxTLEzh5UL62'>Pątnów 14a,<br/>98 - 335 Pątnów</a></p>
        <p>Tel: <a href={`tel:${Config.tel.num}`}>{Config.tel.text}</a></p>
        {Config.email && <p>Email: <a href={`mailto:${Config.email}`}>{Config.email}</a></p>}

        <div className={styles.MapContainer}>
          <iframe className={styles.Map} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2502.8793479559254!2d18.600433316151165!3d51.14757597957764!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471083bd09f0653b%3A0x8c37532fcaa27f87!2sStolarstwo+Zbigniew+Grze%C5%BCu%C5%82kowski!5e0!3m2!1spl!2spl!4v1515772249690" title='map' frameBorder="0" allowFullScreen/>
        </div>
      </div>
    );
  }
}

export default Contact;
